import client from '../../../apis/client'
import { AxiosPromise } from 'axios'
import { Prescription } from '../../../types/models/Presc'
import { FormatStatus } from '../latest/formatSetting/hospitalCode'

/**
 * annotator の閲覧（latest UI）用 API。**読み取りだけ**。
 *
 * 顧客側の `/prescriptions` とは別の名前空間（`api/annotator/`）で、
 * backend では User.pharmacy_scope_q を通らない別経路になっている。
 * ここに書き込みの関数を足さないこと。この面で書けるのは医療機関の様式（フォーマット設定）だけで、
 * それは `formatSetting.ts` に隔離してある — 読取結果・報告・顧客データへの書き込みは 1 本も無い。
 */

export type AnnotatorPharmacy = {
  id: string
  name: string
  company_name: string
}

export type AnnotatorPharmacyListResponse = {
  pharmacies: AnnotatorPharmacy[]
  /** 上限で打ち切られた。「候補が無い」と取り違えさせないために出す */
  has_more: boolean
}

export type AnnotatorPrescriptionListResponse = {
  pharmacy: AnnotatorPharmacy
  days_back: number
  /** 期間内の OCR イベント総数（打ち切り前） */
  total_events: number
  /** 上限で打ち切られた。一覧が全部ではないことを利用者に伝える */
  has_more: boolean
  /** 形が壊れていて描けなかった行数。黙って減らさない */
  skipped: number
  prescriptions: Prescription[]
  /**
   * 統一医療機関コード（10 桁）→ 様式の判断済みフラグ。行には足さず兄弟キーで来る
   * （行の形を顧客側 PrescriptionSerializer と揃えたまま「様式未設定」を出すため）
   */
  format_status: Record<string, FormatStatus>
}

/** 薬局を検索する。keyword は店舗名と法人名の両方に当たる。 */
export const getAnnotatorPharmacies = (
  keyword: string
): AxiosPromise<AnnotatorPharmacyListResponse> =>
  client.get('api/annotator/pharmacies/', {
    params: keyword ? { q: keyword } : {},
  })

/** 指定店舗の処方箋一覧。days_back を省くと backend の既定（1 週間）。 */
export const getAnnotatorPrescriptions = (
  pharmacyId: string,
  daysBack?: number
): AxiosPromise<AnnotatorPrescriptionListResponse> =>
  client.get('api/annotator/prescriptions/', {
    params:
      daysBack === undefined
        ? { pharmacy_id: pharmacyId }
        : { pharmacy_id: pharmacyId, days_back: daysBack },
  })
